var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DED2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1107 14.5137C31.8525 12.2544 28.4077 12.0381 26.4172 14.0285L20.9961 19.4501L17.2449 23.2004C15.2544 25.1914 15.4713 28.6355 17.7295 30.8954C19.9883 33.1535 23.4331 33.3697 25.4236 31.3799L29.1741 27.6289L34.5959 22.208C36.587 20.217 36.3695 16.7724 34.1107 14.5137ZM24.4568 30.412C23.0024 31.8664 20.4189 31.6483 18.6974 29.9275C16.9765 28.2061 16.7584 25.6233 18.2128 24.1683L21.9634 20.418L28.2074 26.6617L24.4568 30.412Z",
    fill: "#372C65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0474 31.777C22.7711 34.0393 19.0936 34.0336 16.8244 31.7643C14.5346 29.4745 14.5526 25.7565 16.8644 23.4889L21.4517 18.9895L29.4847 27.3671L25.0474 31.777Z",
    fill: "#8C82B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMedicationIcon);
export default __webpack_public_path__ + "static/media/card-medication-icon.d971e7fe4591a4782a340620c827e8c6.svg";
export { ForwardRef as ReactComponent };